import { AppointmentDetails } from "../types";

export const getAllAttendees = (details: AppointmentDetails): string[] => {
  return [...details.requiredAttendees, ...details.optionalAttendees];
};

export const getAttendeeCount = (details: AppointmentDetails): number => {
  return getAllAttendees(details).length;
};

export const formatAttendeeCount = (count: number): string => {
  return `${count} ${count === 1 ? "attendee" : "attendees"}`;
};
